import get from "lodash/get";

import { calculateFreeTrialDaysLeft } from "../utils/user-helpers";

/**
 * If the coach is in free trial mode and it has expired, he must be redirected to upgrade page
 */

async function ensureCoachUpgrade({ res, locals, load, api }, next) {
  const { activeUser, momentTZ, organizationOwner, activeUserToRequest } =
    locals;
  const periodEnd = momentTZ(get(activeUserToRequest, "stripe.period_end"));

  // if not logged in or not an athlete then don't do anything
  if (!activeUser || !activeUser.coach) return next();

  const userToRequestWithOrg =
    !activeUser.organizationId && !organizationOwner
      ? activeUser.coach._id
      : organizationOwner._id;

  const userToRequest = await (
    await api(`user/${userToRequestWithOrg}`)
  ).json();

  await load("coach", { user: userToRequest._id });
  const coach = locals.coach;

  if (coach && coach.coachingFreeTrial) {
    const daysLeft = calculateFreeTrialDaysLeft(coach);
    if (daysLeft < 1 && periodEnd.add(7, "days") <= momentTZ()) {
      return res.redirect("/upgrade-1");
    }
  }

  return next();
}

export default ensureCoachUpgrade;
